module.exports = __webpack_public_path__ + "static/media/silkycloud-3.90771d82.png";